export const bulkCalendarDrawer = {
  header: {
    eyebrow: "Edición masiva",
    title: "Calendario en lote",
    subtitle: "Cierra, abre o ajusta varias unidades de forma simultánea.",
  },
  actions: {
    close: {
      label: "Cerrar fechas",
      hint: "Aplica bloqueo manual respetando reservas y sincronización.",
    },
    open: {
      label: "Abrir fechas",
      hint: "Reabre solo los días seleccionados sin tocar el resto del cierre.",
    },
    price: {
      label: "Cambiar precio",
      hint: "Actualiza precio por noche en las fechas y alojamientos elegidos.",
    },
    minStay: {
      label: "Estancia mínima",
      hint: "Define mínimo de noches por fecha de forma masiva.",
    },
  },
  microcopy: {
    close: "Bloqueo manual",
    open: "Apertura parcial",
    price: "Tarifa por noche",
    minStay: "Noches mínimas",
  },
  step1: {
    title: "Qué quieres aplicar",
    hintEmpty: "Elige una acción para empezar.",
  },
  step2: {
    title: "Dónde aplicar",
    selectedCount: "{selected} de {total} seleccionados",
    selectVisible: "Visibles",
    selectAll: "Todos",
    clear: "Limpiar",
    searchPlaceholder: "Buscar alojamiento…",
    empty: "No hay alojamientos que coincidan con la búsqueda.",
  },
  step3: {
    title: "Rango y días",
    datesInRange: "{count} fecha en el rango | {count} fechas en el rango",
    from: "Desde",
    to: "Hasta",
    presetAll: "Todos",
    presetWeekdays: "L–V",
    presetWeekend: "Finde",
  },
  step4: {
    closeReasonTitle: "Motivo del cierre",
    availabilityTitle: "Disponibilidad",
    closeReasonHint: "Opcional — quedará registrado en el bloqueo.",
    availabilityHint: "Se cierra la venta (stop-sell); la disponibilidad se conserva. Cámbiala solo si quieres.",
    closeCommentPlaceholder: "Ej. mantenimiento o uso del propietario",
    availabilityPlaceholder: "Habitaciones a la venta (vacío = conservar)",
    openAvailabilityHint: "Reabre la venta. Indica cuántas habitaciones ofrecer (vacío = conservar la actual).",
    availabilityPlaceholderOpen: "Habitaciones a la venta",
  },
  ratePlan: {
    title: "Tarifa a modificar",
    hint: "Este tipo tiene varias tarifas. Elige a cuál(es) aplicar {target}. Las derivadas se ajustan solas.",
    targetPrice: "el precio",
    targetMinStay: "la estancia mínima",
    default: "estándar",
    roomsCount: "{count} hab. | {count} hab.",
    multiUnitNote: "Se aplicará en cada habitación que tenga la tarifa elegida.",
    fallbackName: "Tarifa",
  },
  price: {
    title: "Nuevo precio por noche",
    hint: "Se aplicará a las fechas, unidades y tarifas elegidas.",
    mixedCurrencyWarning: "Selecciona solo alojamientos con la misma moneda.",
    placeholder: "Valor",
    placeholderCurrency: "Valor en {currency}",
    hintPercent: "Sube o baja el precio que ya tiene cada noche.",
    modeGroupLabel: "Tipo de cambio de precio",
    modeFixed: "Precio fijo",
    modeFixedHint: "El mismo importe en todas las noches.",
    modePercent: "Porcentaje",
    modePercentHint: "Sobre el precio de cada noche.",
    modeAmount: "Importe",
    modeAmountHint: "Sumar o restar sobre cada noche.",
    amountPlaceholder: "Ej. 10",
    amountHint: "Se suma a lo que ya vale cada noche. Con el signo − baja.",
    percentPlaceholder: "Ej. 20",
    percentHint: "Cada noche se recalcula sobre su propio precio. Con el signo − baja (entre {min} % y {max} %).",
    toggleSign: "Cambiar entre subir y bajar",
    invalidPercent: "Escribe un porcentaje entre {min} % y {max} %, distinto de 0.",
  },
  minStay: {
    title: "Estancia mínima",
    hint: "Número mínimo de noches por fecha.",
    placeholder: "Ej. 2",
  },
  summary: {
    empty: "Selecciona unidades y rango.",
    unitOne: "unidad",
    unitMany: "unidades",
    dateOne: "fecha",
    dateMany: "fechas",
    ready: "{propertyCount} {propertyLabel} · {dateCount} {dateLabel} listas para aplicar.",
    nightOne: "noche",
    nightMany: "noches",
    readyPriceFixed: "{propertyCount} {propertyLabel} · pondrá {price} {currency} en {dateCount} {nightLabel}.",
    readyPricePlus: "{propertyCount} {propertyLabel} · subirá {amount} {currency} el precio de {dateCount} {nightLabel}.",
    readyPriceMinus: "{propertyCount} {propertyLabel} · bajará {amount} {currency} el precio de {dateCount} {nightLabel}.",
    readyPriceUp: "{propertyCount} {propertyLabel} · subirá un {percent} % el precio de {dateCount} {nightLabel}.",
    readyPriceDown: "{propertyCount} {propertyLabel} · bajará un {percent} % el precio de {dateCount} {nightLabel}.",
  },
  footer: {
    cancel: "Cancelar",
    apply: "Aplicar cambios",
    applying: "Aplicando…",
  },
  weekdays: {
    mon: { short: "L", long: "Lunes" },
    tue: { short: "M", long: "Martes" },
    wed: { short: "X", long: "Miércoles" },
    thu: { short: "J", long: "Jueves" },
    fri: { short: "V", long: "Viernes" },
    sat: { short: "S", long: "Sábado" },
    sun: { short: "D", long: "Domingo" },
  },
  ownerBlockComment: "Bloqueo por el propietario",
};
